import { render, staticRenderFns } from "./ImportDia.vue?vue&type=template&id=143107f3&scoped=true"
import script from "./ImportDia.vue?vue&type=script&lang=js"
export * from "./ImportDia.vue?vue&type=script&lang=js"
import style0 from "./ImportDia.vue?vue&type=style&index=0&id=143107f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143107f3",
  null
  
)

export default component.exports